import { useState } from 'react';
import { useRetirementIncomeColors } from '../../hooks/useRetirementIncomeColors';
import { ValuesKeys } from '../../useRetirementIncome';

interface BreakDownItem {
  name: string;
  key: ValuesKeys | string;
  fontWeight?: 600;
  hasDot?: boolean;
  color?: string;
  isDetail?: boolean;
}

const breakDown: BreakDownItem[] = [
  {
    key: 'socialSecurity',
    name: 'Social Security',
    isDetail: true,
    hasDot: true,
  },
  {
    key: 'pension',
    name: 'Pension',
    isDetail: true,
    hasDot: true,
  },
  {
    key: 'annuity',
    name: 'Annuities',
    isDetail: true,
    hasDot: true,
  },
  {
    key: 'totalGuaranteedIncome',
    name: 'Total Guaranteed Income',
    fontWeight: 600,
  },
  {
    key: 'livingExpenses',
    name: 'Living Expenses',
  },
  {
    key: 'separator-1',
    name: 'separator',
  },
  {
    key: 'guaranteedIncomeShortage',
    name: 'Guaranteed Income Shortage',
    fontWeight: 600,
    color: 'error.600',
  },
  {
    key: 'distributions',
    name: 'Distributions',
    hasDot: true,
  },
  {
    key: 'otherIncome',
    name: 'Other',
    hasDot: true,
  },
  {
    key: 'separator-2',
    name: 'separator',
  },
  {
    key: 'incomeShortage',
    name: 'Income Shortage',
    hasDot: true,
    fontWeight: 600,
  },
];

export const useBreakdown = () => {
  const [showDetails, setShowDetails] = useState(false);

  const retirementIncomeColors = useRetirementIncomeColors();

  return {
    breakDown,
    showDetails,
    setShowDetails,
    retirementIncomeColors,
  };
};
